import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { rupee } from "@/lib/constants";
import { CareShell } from "@/components/CareShell";
import { HcHeader } from "@/components/care/HcHeader";
import { HC_TILES, HC_CARD } from "@/components/care/HealthcareCard";
import { Loader2, ChevronRight } from "lucide-react";

export default function HealthcareBookings() {
    const nav = useNavigate();
    const [rows, setRows] = useState(null);
    useEffect(() => { api.get("/care/healthcare/bookings").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
    return (
        <CareShell>
            <HcHeader title="Healthcare bookings" back="/care/healthcare" />
            <div className="space-y-3 px-5 pb-10">
                {rows === null ? <div className="flex justify-center py-16"><Loader2 className="h-7 w-7 animate-spin text-teal" /></div>
                    : rows.length ? rows.map((b) => {
                        const t = HC_TILES.find((x) => x.kind === b.kind);
                        return (
                            <button key={b.id} data-testid={`hc-booking-${b.ref}`} onClick={() => nav(`/care/healthcare/bookings/${b.id}`)} className={`${HC_CARD} flex w-full items-center gap-3 p-4 text-left transition-transform active:scale-[0.98]`}>
                                {t && <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-aqua-light text-teal"><t.icon size={21} /></span>}
                                <div className="min-w-0 flex-1"><p className="font-heading text-sm font-bold text-navy">{b.kind_label} · {b.patient_name}</p><p className="text-xs text-navy/55">{b.ref} · {b.date} · {b.slot} · {rupee(b.total)}</p>
                                    <span data-testid={`hc-booking-status-${b.ref}`} className="mt-1 inline-block rounded-full bg-aqua-light px-2 py-0.5 text-[10px] font-bold text-teal-dark">{b.status}</span></div>
                                <ChevronRight size={16} className="text-navy/30" />
                            </button>
                        );
                    }) : <p className="py-12 text-center text-sm text-navy/45">No healthcare bookings yet.</p>}
            </div>
        </CareShell>
    );
}
